import { Dropdown, Layout, theme } from "antd";
import { Avatar } from "antd";
import {
  BgColorsOutlined,
  LogoutOutlined,
  UserOutlined,
  DesktopOutlined,
  MoonOutlined,
  SunOutlined,
  MenuOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { useAuth } from "src/features/auth/AuthContext";
import { useThemeStore, ThemeMode } from "src/stores/ThemeStore";
import { useScreenStore } from "src/stores/screenStore";
import ExchangeRateChip from "src/components/ExchangeRateChip";

const { Header } = Layout;

interface LayoutHeaderProps {
  onMenuClick?: () => void;
}

const LayoutHeader = ({ onMenuClick }: LayoutHeaderProps) => {
  const { token } = theme.useToken();
  const navigate = useNavigate();
  const { user, logout } = useAuth();
  const themeMode = useThemeStore((s) => s.themeMode);
  const setTheme = useThemeStore((s) => s.setTheme);
  const screens = useScreenStore((s) => s.screens);

  const themeItems = [
    { key: "light", icon: <SunOutlined />, label: "라이트" },
    { key: "dark", icon: <MoonOutlined />, label: "다크" },
    { key: "system", icon: <DesktopOutlined />, label: "시스템" },
  ];

  return (
    <Header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: screens.sm ? "0 24px" : "0 12px",
        background: token.colorBgContainer,
        borderBottom: `1px solid ${token.colorBorderSecondary}`,
        position: "sticky",
        top: 0,
        zIndex: 100,
        height: 56,
        lineHeight: "56px",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        {!screens.md && (
          <MenuOutlined onClick={onMenuClick} style={{ fontSize: 18, cursor: "pointer" }} />
        )}
        <img
          src="/finhub-icon.svg"
          alt="FinHub"
          width={26}
          height={26}
          style={{ display: "block" }}
        />
        <span
          style={{ fontSize: screens.sm ? 16 : 14, fontWeight: 700, cursor: "pointer" }}
          onClick={() => navigate("/")}
        >
          FinHub
        </span>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <ExchangeRateChip />

        <Dropdown
          menu={{
            items: themeItems,
            selectedKeys: [themeMode],
            onClick: ({ key }) => setTheme(key as ThemeMode),
          }}
          trigger={["click"]}
        >
          <BgColorsOutlined style={{ fontSize: 16, cursor: "pointer", color: token.colorTextSecondary }} />
        </Dropdown>

        <Dropdown
          menu={{
            items: [
              {
                key: "profile",
                icon: <UserOutlined />,
                label: user?.name || user?.email || "사용자",
                onClick: () => navigate("/profile"),
              },
              { type: "divider" },
              { key: "logout", icon: <LogoutOutlined />, label: "로그아웃", onClick: logout },
            ],
          }}
          trigger={["click"]}
        >
          <Avatar
            size={30}
            icon={<UserOutlined />}
            src={user?.photo || undefined}
            style={{ cursor: "pointer" }}
          />
        </Dropdown>
      </div>
    </Header>
  );
};

export default LayoutHeader;
